import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "./LandingPage.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { floraFaunaNavigationItems } from "../../../utils/NavigationHelper";
import { Button } from "@onegovbugs/onegov-react-components";
import { FLORAFAUNA_FORM,Flora_Fauna_Licence_TypeName } from "../../../constants";
import { clearForm, storeCaptcha, setCurrentForm } from "../../../redux/actions";

const LandingPage = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearForm());
    dispatch(setCurrentForm(FLORAFAUNA_FORM, Flora_Fauna_Licence_TypeName));
    const payload = {
      [FLORAFAUNA_FORM]: false,
    };
    dispatch(storeCaptcha(payload));
  }, [dispatch]);

  const captcha = useSelector((state) => state.captcha);

  const renderSection = (title, goTo) => {
    return (
      <div className={styles.mainCont}>
        <div className={"row"}>
          <div className={"col-12"}>
            <h3>What you need to know</h3>
            <br />
            <p>
              You will require a licence under the <a href='https://www.legislation.nsw.gov.au/view/html/inforce/current/act-2016-063' target='_blank'><i>Biodiversity Conservation Act
              2016</i></a> if you wish to undertake an activity for scientific,
              education or conservation purposes, that is likely to result in
              one or more of the following:
            </p>
            <li>
              Harm a protected native animal, or an animal that is a threatened
              species or part of a threatened ecological community.
            </li>
            <li>
              Pick a protected native plant, or a plant that is a threatened
              species or is part of a threatened ecological community.
            </li>
            <li>
              Damage to a declared area of outstanding biodiversity values.
            </li>
            <li>
              Damage to a habitat of a threatened species or a threatened ecological community.
            </li>
            <li>
              You will also need a licence if you plant to collect voucher
              specimens for identifcation purposes, pick cuttings or whole
              plants, or collect seed.
            </li>
            <br />
            <p>
              Please allow 4-6 weeks for your application to be processed. For
              work within the NPWS reserve system, applicants are encouraged to
              discuss their proposal with the relevant park managers prior to
              submitting their application. Please provide details of any
              agreements or support for your proposal provided by the area
              offices as this will assist in the assessment process.
            </p>
          </div>
        </div>

        {process.env.REACT_APP_CAPTCHA_ENABLED == "true" && (
          <div className={`row ${styles.buttonCont}`}>
            <div className={`col-12`}>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                onChange={(value) => {
                  const payload = {
                    [FLORAFAUNA_FORM]: value !== null,
                  };
                  dispatch(storeCaptcha(payload));
                }}
              />
            </div>
          </div>
        )}
        {(captcha[FLORAFAUNA_FORM] ||
          process.env.REACT_APP_CAPTCHA_ENABLED === "false") && (
          <div className={`row`}>
            <div className={`col-6`}>
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  props.history.push(goTo);
                }}
              >
                Start Application
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={`col-12`}>
          <h1>Apply for Flora And Fauna Research Licence</h1>
          {renderSection(
            "Flora And Fauna",
            `/flora-fauna/class-detail`
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <LandingPage {...props} />);
